import { authAPI } from './api';
import type { DashboardRoleKey } from '../config/dashboardWidgetCatalog';
import type { WidgetConfig, WidgetPreferences } from '../hooks/useWidgetPreferences';

export interface DashboardPreferenceDTO {
  company_id: string;
  dashboard_role_key: string;
  layout_mode: 'grid' | 'list';
  widgets: WidgetConfig[];
  updated_at?: string;
  schema_version?: number;
}

export async function getDashboardPreferences(
  companyId: string,
  dashboardRoleKey: DashboardRoleKey
): Promise<{ data: DashboardPreferenceDTO | null; useDefault: boolean }> {
  const response = await authAPI.get<DashboardPreferenceDTO | null>('/users/dashboard-preferences', {
    params: { company_id: companyId, dashboard_role_key: dashboardRoleKey },
  });
  const useDefault = response.headers['x-use-default'] === 'true' || response.data === null;
  return { data: response.data, useDefault };
}

export async function upsertDashboardPreferences(
  companyId: string,
  dashboardRoleKey: DashboardRoleKey,
  preferences: WidgetPreferences
): Promise<DashboardPreferenceDTO> {
  const response = await authAPI.put<DashboardPreferenceDTO>('/users/dashboard-preferences', {
    company_id: companyId,
    dashboard_role_key: dashboardRoleKey,
    layout_mode: preferences.layout,
    widgets: preferences.widgets,
    schema_version: 1,
  });
  return response.data;
}

export async function deleteDashboardPreferences(
  companyId: string,
  dashboardRoleKey: DashboardRoleKey
): Promise<void> {
  await authAPI.delete('/users/dashboard-preferences', {
    params: { company_id: companyId, dashboard_role_key: dashboardRoleKey },
  });
}
